var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjects = function SvgProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    "data-name": "Component 1 \\u2013 1",
    viewBox: "0 0 18 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313237",
    d: "M16 4h-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2v2a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M2 16V2h10v2H6a2 2 0 0 0-2 2v10Zm4 4V6h10v14Z",
    "data-name": "Path 56",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#313237",
    d: "M13 8H9a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2",
    "data-name": "Path 57",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#313237",
    d: "M11 11H9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2",
    "data-name": "Path 58",
    opacity: 0.7
  })));
};
export default SvgProjects;